import React from 'react'
import { Container } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import { TypeAnimation } from 'react-type-animation';
import Contactop from '../About/Contactop';

const Contacto = () => {
  return (
<>
    <div className='separador'>
        <h3 className='colorini titulo-servicio'><TypeAnimation
        sequence={[
            "Contacto.",500,
          ]} 
          repeat={0}
        
        style={{ fontSize: '1.5em' }}/></h3></div>
<Container fluid>
  
<div className='div-desarrollo' data-aos="fade-right">
<p className="parrafo-servicio" style={ { color:"White",}}>
¿Estas listo para llevar tu emprendimiento/empresa al siguiente nivel en el mundo digital? ¡Nos encantaria que puedas contarnos sobre vos!, Ponete en contacto con nosotros hoy mismo para empezar a trabajar juntos en tu proyecto.
  </p>
  <br></br>
  <p className="parrafo-servicio" style={ { color:"White",}}>

Ya sea que estes buscando crear una pagina web simple pero atractiva para tu negocio, o necesites desarrollar una aplicacion web personalizada para optimizar tus operaciones, estamos aqui para ayudarte en cada paso del camino. Nuestra prioridad es entender tus necesidades unicas y ofrecerte soluciones que se adapten perfectamente a tus objetivos y presupuesto.
  </p>
  <h3 className='titulo-servicio'>No esperes mas!! Llena el formulario de contacto para poder conocernos!! </h3>
</div>
<Contactop/>
</Container>
<div className='separador-f'>
        <Footer/>
        </div>        
  </>
  )
}

export default Contacto